module.exports = __webpack_public_path__ + "static/img/30.20b4c37e.png";